/* eslint-disable */
import axios, { AxiosResponse } from 'axios';
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './styles/style.module.scss';
import Plans from './layouts/plans';
import Footer from '../../layouts/footer';
import Button from '../../components/ui/button/Button';
import Separator from './layouts/separator';
import tashaImg from '../../assets/images/tashaWithoutFace.png';
import sophiaImg from '../../assets/images/sophiaWithoutFace.png';
import isabellaImg from '../../assets/images/IsabellaWithotFace.png';
import jamesImg from '../../assets/images/james.webp';
import danielImg from '../../assets/images/daniel.webp';
import michaelImg from '../../assets/images/michael.webp';
import { useStore } from '../../store/store';
import { ReactComponent as StarSvg } from '../../assets/images/star.svg';
import { ReactComponent as HandSvg } from './styles/hand.svg';
import { debounce } from 'lodash';
import { selectProducts } from 'core/store/billing/selectors';
import { useRemoteConfig } from 'core/hooks/use-remote-config';
import { t } from '@web-solutions/module-localization';
import getLocale from '../../../localization/get-locale';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { Text } from 'src/onboarding/components/typography/Text/Text';
import { Caption } from 'src/onboarding/components/typography/Caption/Caption';
import { getEnvUrl } from 'src/onboarding/helpers/getEnvUrl';
import { Allergies, UserPayload, UserResponse } from 'src/onboarding/types/api';
import card from '../../assets/images/cardPlanMetabolism.png';
import { ReactComponent as PeopleIcon } from '../../assets/images/peopleIcon.svg';
import { ReactComponent as ReviewIcon } from '../../assets/images/reviewIcon.svg';
import { ReactComponent as TimeSvg } from '../../assets/images/timeBestApp.svg';
import { ReactComponent as CosmostyleSvg } from '../../assets/images/cosmostyle.svg';
import { ReactComponent as RalsimpleSvg } from '../../assets/images/ralsimple.svg';
import { ReactComponent as ParadSvg } from '../../assets/images/parad.svg';
import { ReactComponent as PurewonSvg } from '../../assets/images/purewon.svg';
import { ReactComponent as PsSvg } from '../../assets/images/ps.svg';
import { ReactComponent as UnlockIcon } from './styles/unlockIcon.svg';
import { ReactComponent as CheckIcon } from './styles/checkGrayIcon.svg';
import { ReactComponent as GiftIcon } from './styles/giftIcon.svg';
import people from './styles/people.png';
import { EmailPopup } from 'src/onboarding/components/ui/email-popup/EmailPopup';
import { GiftPopup } from 'src/onboarding/components/ui/gift-popup/GiftPopup';
import { renderHighlightedTitle } from 'src/onboarding/helpers/renderHighlightedTitle';
import { applyFoodzeeAuthTokens } from 'src/onboarding/helpers/applyFoodzeeAuthTokens';

declare const gtag: Function;

const EMAIL_POPUP_KEY = 'email_popup_shown';
const GIFT_POPUP_KEY = 'gift_popup_shown';

interface Customer {
  img: string;
  name: string;
  descriptions: string;
  weightLeft: number;
  weightRight: number;
}

interface PlansRef {
  onPayment: () => void;
}

function addDaysToDate(days: string): string {
  const daysNumber = parseInt(days, 10);
  if (isNaN(daysNumber)) {
    return '';
  }

  const currentDate = new Date();
  currentDate.setDate(currentDate.getDate() + daysNumber);

  const formatter = new Intl.DateTimeFormat('en-GB', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
  const formattedDate = formatter.format(currentDate);
  console.log('formattedDate ', formattedDate);
  return formattedDate;
}

const PersnalPlan = () => {
  const dispatch = useDispatch();
  const locale = getLocale();
  const childRef = useRef<PlansRef>(null);
  const state = useStore((state) => state);
  const {
    setPage,
    email,
    born: age,
    gender,
    preferences: dietary,
    height,
    weight,
    setUserId,
    savedOnboarding,
    setSavedOnboarding,
    existTimeoutId,
  } = state;

  const productsObj = useSelector(selectProducts);
  const {
    specialOffer,
    products,
    routeGroups: flow,
    showEmailPopup,
    showPlanDescription,
    showGiftPopup,
    paymentSystem,
  } = useRemoteConfig();

  const [showDownSaleModalOnce, setShowDownSaleModalOnce] = useState(false);
    const [isEmailPopupOpen, setIsEmailPopupOpen] = useState(
      true && !sessionStorage.getItem(EMAIL_POPUP_KEY)
    );
    
    const [isGiftPopupOpen, setIsGiftPopupOpen] = useState(false);
    
  const [isDownSaleModalOpen, setIsDownSaleModalOpen] = useState(false);

 useEffect(() => {
    if (showEmailPopup && !sessionStorage.getItem(EMAIL_POPUP_KEY)) {
      setIsEmailPopupOpen(true);
    } else if (showGiftPopup && !sessionStorage.getItem(GIFT_POPUP_KEY)) {
      setIsGiftPopupOpen(true);
    }
  }, []);

  const handleEmailPopupClose = () => {
    setIsEmailPopupOpen(false);
    sessionStorage.setItem(EMAIL_POPUP_KEY, 'true');
  
    if (showEmailPopup) {
      setIsGiftPopupOpen(true);
    }
  };

  const handleGiftPopupClose = () => {
    setIsGiftPopupOpen(false);
    sessionStorage.setItem(GIFT_POPUP_KEY, 'true');
  };

  const { apiBaseUrl } = getEnvUrl();

  useEffect(() => {
    gtag('event', 'conversion', {
      send_to: 'AW-17149973324/gwbSCMu_yP0aEMym3_E_',
      value: 1.5,
      currency: 'USD',
    });
  }, []);

  useEffect(() => {
    return () => {
      clearTimeout(existTimeoutId);
    };
  }, [existTimeoutId]);

  const icons = [
    <TimeSvg />,
    <CosmostyleSvg />,
    <RalsimpleSvg />,
    <ParadSvg />,
    <PurewonSvg />,
    <PsSvg />,
  ];
  const duplicatedIcons = [...icons, ...icons];

  const customers: Customer[] = [
    {
      img: tashaImg,
      name: t('onboarding.personalPlan.customers.1.name'),
      descriptions: t('onboarding.personalPlan.customers.1.descriptions'),
      weightLeft: 75,
      weightRight: 60,
    },
    {
      img: sophiaImg,
      name: t('onboarding.personalPlan.customers.2.name'),
      descriptions: t('onboarding.personalPlan.customers.2.descriptions'),
      weightLeft: 80,
      weightRight: 60,
    },
    {
      img: isabellaImg,
      name: t('onboarding.personalPlan.customers.3.name'),
      descriptions: t('onboarding.personalPlan.customers.3.descriptions'),
      weightLeft: 90,
      weightRight: 55,
    },
  ];

  const customersMen: Customer[] = [
    {
      img: jamesImg,
      name: t('onboarding.personalPlan.customersMen.1.name'),
      descriptions: t('onboarding.personalPlan.customersMen.1.description'),
      weightLeft: 128,
      weightRight: 96,
    },
    {
      img: danielImg,
      name: t('onboarding.personalPlan.customersMen.2.name'),
      descriptions: t('onboarding.personalPlan.customersMen.2.description'),
      weightLeft: 107,
      weightRight: 85,
    },
    {
      img: michaelImg,
      name: t('onboarding.personalPlan.customersMen.3.name'),
      descriptions: t('onboarding.personalPlan.customersMen.3.description'),
      weightLeft: 124,
      weightRight: 97,
    },
  ];

  console.log('products ', products);
  const productDescription = showDownSaleModalOnce
    ? {
        name: specialOffer.products[0]?.name,
        plan_end_days: addDaysToDate(specialOffer.products[0]?.plan_end_days),
        subTitle: specialOffer.products[0]?.subTitle[locale],
        title: specialOffer.products[0]?.title[locale],
        price: specialOffer.products[0]?.priceStartTrial.price,
      }
    : {
        name: products[0]?.name,
        plan_end_days: addDaysToDate(products[0]?.priceStartTrial.plan_end_days),
        subTitle: products[0]?.subTitle[locale],
        title: products[0]?.title[locale],
        price: products[0]?.priceStartTrial.price[locale],
      };
  const { name, plan_end_days, subTitle, title, price } = productDescription;

  const payment = () => {
    childRef.current.onPayment();
  };

  const setOnboardingData = useCallback(
    debounce(async () => {
      try {
        const payload: UserPayload = {
          email,
        };

        const response: AxiosResponse<UserResponse> = await axios.post(
          `${apiBaseUrl}/v2/user`,
          payload
        );

        if (response.status === 201) {
          const filteredState = Object.fromEntries(
            Object.entries({ ...state }).filter(
              ([key, value]) => typeof value !== 'function' && key !== 'faceScanBase64'
            )
          );

          setUserId(response.data.uid);
          applyFoodzeeAuthTokens(response.data, dispatch, { reinitBilling: true, paymentSystem });

          await axios.post(`${apiBaseUrl}/onboarding`, {
            json: JSON.stringify(filteredState),
            user_id: response.data.uid,
          });
        }

        setSavedOnboarding(true);
      } catch (error) {
        // need change
        setSavedOnboarding(true);
        console.error('Error:', error);
      }
    }, 500),
    [email, gender, height, weight, state]
  );

  useEffect(() => {
    if (showEmailPopup && isEmailPopupOpen) {
      return;
    }

    if (!savedOnboarding) {
      setOnboardingData();
    }
    return () => {
      setOnboardingData.cancel();
    };
  }, [setOnboardingData, savedOnboarding, showEmailPopup, isEmailPopupOpen]);

  return (
    <>
      <div className={styles.page}>
        <div className={styles.container}>
          <Title tag='h2' className={styles.title}>
            {t('onboarding.personalPlanMetabolism.title')}
          </Title>
          <Text size='m' medium style={{ color: '#3F3F3F' }}>
            {t('onboarding.personalPlanMetabolism.subTitle')}
          </Text>

          <div className={styles.image} style={{ backgroundImage: `url(${card})` }} />
          <div className={styles.stats}>
            <div className={styles.statsItem}>
              <PeopleIcon />
              <Caption size='l' className={styles.statsDesc}>
                <span>1,300+</span> people took the quiz today
              </Caption>
            </div>
            <div className={styles.statsItem}>
              <ReviewIcon />
              <Caption size='l' className={styles.statsDesc}>
                Trusted by <span>1.8M+</span> users worldwide
              </Caption>
            </div>
          </div>
          <div className={styles.content}>
            <div className={styles.list}>
              <div className={styles.animationList}>{duplicatedIcons}</div>
            </div>
          </div>
          <div className={styles.bodyContainer}>
            <Plans
              ref={childRef}
              showDownSaleModalOnce={showDownSaleModalOnce}
              setShowDownSaleModalOnce={setShowDownSaleModalOnce}
              onDownSaleModalToggle={setIsDownSaleModalOpen}
            />
            {/* <Button className={styles.startTrialBtn} title='Start Trial and Cantinue'/> */}
            <span className={styles.privacy}>
              {t('onboarding.personalPlan.plan.accept')}{' '}
              <a onClick={() => setPage('privacy-policy')}>
                {t('onboarding.personalPlan.plan.privacy')}
              </a>
              ,{' '}
              <a onClick={() => setPage('terms-of-use')}>
                {t('onboarding.personalPlan.plan.terms')}
              </a>
            </span>
            <Separator />

            <div className={styles.bodyBalanceContainer}>
              <Title tag='h4'>{t('onboarding.personalPlanMetabolism.bodyBalance.title')}</Title>
              <div>
                <Text size='m' medium style={{ color: '#8A8A8A' }}>
                  {t('onboarding.personalPlanMetabolism.bodyBalance.description')}
                </Text>
                <Text
                  size='m'
                  medium
                  className={styles.bodyBalanceDesc}
                  style={{ color: '#8A8A8A' }}
                >
                  {t('onboarding.personalPlanMetabolism.bodyBalance.description')}
                </Text>
                <div className={styles.unlock}>
                  <UnlockIcon />
                  <Text size='l' semibold style={{ color: '#00CE00' }}>
                    {t('onboarding.personalPlanMetabolism.bodyBalance.unlock')}
                  </Text>
                </div>
              </div>
            </div>

            <Button
              className={styles.startTrialBtn}
              title={t('onboarding.personalPlanMetabolism.bodyBalance.getReport')}
              onClick={payment}
            />

            <div className={styles.tryFoodzeeContainer}>
              <Title tag='h4'>
                {renderHighlightedTitle(t('onboarding.personalPlanMetabolism.tryFoodzee.title'))}
              </Title>
              <div className={styles.featuresList}>
                {['discover', 'access', 'mealPlan', 'swapMeals', 'dailyInsights']
                  .concat(showPlanDescription ? ['trial'] : [])
                  .map((feature) => (
                    <div key={feature} className={styles.featureItem}>
                      <CheckIcon />
                      <Text size='m' medium className={styles.featureText}>
                        {feature === 'trial'
                          ? t(`onboarding.personalPlanMetabolism.tryFoodzee.${feature}`)
                              .replace('$4.99', `$${products[0]?.priceStartTrial.billedAmount}`)
                              .replace('$39.99', `$${products[0]?.priceStartTrial.price.en}`)
                          : t(`onboarding.personalPlanMetabolism.tryFoodzee.${feature}`)}
                      </Text>
                    </div>
                  ))}
              </div>

              <div className={styles.promoSection}>
                <div className={styles.discountInfo}>
                  <GiftIcon />
                  <div>
                    <Text size='m' bold>
                      {t('onboarding.personalPlanMetabolism.tryFoodzee.discount')}
                    </Text>
                    <Text size='m' regular>
                      {t('onboarding.personalPlanMetabolism.tryFoodzee.youSave')}
                    </Text>
                  </div>
                </div>
              </div>
              <div className={styles.pricingInfo}>
                <Text size='l' semibold>
                  {t('onboarding.personalPlanMetabolism.tryFoodzee.total')}
                </Text>
                <div className={styles.prices}>
                  <div className={styles.pricesNew}>
                    <Text size='m' medium className={styles.originalPrice}>
                      {typeof products[0]?.textLineThrough === 'string' &&
                        products[0].textLineThrough}
                    </Text>
                    <Text size='l' semibold className={styles.discountedPrice}>
                      {products[0]?.priceStartTrial.billedAmount}
                    </Text>
                  </div>
                  <Caption size='l' className={styles.savingsText}>
                    {t('onboarding.personalPlanMetabolism.tryFoodzee.youSave')}
                  </Caption>
                </div>
              </div>
            </div>

            <Button
              className={styles.startTrialBtn}
              title={t('onboarding.personalPlanMetabolism.bodyBalance.getReport')}
              onClick={payment}
            />

            <div className={styles.people}>
              <Text size='m' regular style={{ color: '#3F3F3F' }}>
                <span>1,211 </span>
                {t('onboarding.personalPlanMetabolism.tryFoodzee.people')}
              </Text>
              <img src={people} className={styles.peopleImage} alt='people' />
            </div>

            <div className={styles.metabolismContainer}>
              <Title tag='h4'>
                {renderHighlightedTitle(
                  t('onboarding.personalPlanMetabolism.metabolismReport.title')
                )}
              </Title>

              <div className={styles.featuresGrid}>
                {[
                  {
                    icon: '💡',
                    title: t('onboarding.personalPlanMetabolism.metabolismReport.precision'),
                    description: t(
                      'onboarding.personalPlanMetabolism.metabolismReport.precisionDesc'
                    ),
                  },
                  {
                    icon: '🌿',
                    title: t('onboarding.personalPlanMetabolism.metabolismReport.insights'),
                    description: t(
                      'onboarding.personalPlanMetabolism.metabolismReport.insightsDesc'
                    ),
                  },
                  {
                    icon: '💫',
                    title: t('onboarding.personalPlanMetabolism.metabolismReport.balance'),
                    description: t(
                      'onboarding.personalPlanMetabolism.metabolismReport.balanceDesc'
                    ),
                  },
                ].map((feature, index) => (
                  <div key={index} className={styles.featureCard}>
                    <span className={styles.featureIcon}>{feature.icon}</span>
                    <div className={styles.featureContent}>
                      <Text size='l' semibold className={styles.featureTitle}>
                        {feature.title}
                      </Text>
                      <Caption size='l' className={styles.featureDescription}>
                        {feature.description}
                      </Caption>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className={styles.customers} style={{ marginTop: '40px' }}>
              <Title tag='h4' className={styles.customerTitle}>
                {t('onboarding.personalPlan.customersReviews')}
              </Title>
              {(gender === 'Male' ? customersMen : customers).map(
                ({ img, name, descriptions, weightLeft, weightRight }, index) => (
                  <div className={styles.customer} key={index}>
                    <div className={styles.customerImgContainer}>
                      <img className={styles.customerImg} src={img} />
                      <span className={styles.weightLeft}>{weightLeft} kg</span>
                      <span className={styles.weightRight}>{weightRight} kg</span>
                    </div>

                    <div className={styles.customerTop}>
                      <span className={styles.customerName}>{name}</span>
                      <span className={styles.customerRating}>
                        {Array.from({ length: 5 }, (_, i) => (
                          <StarSvg key={i} />
                        ))}
                      </span>
                    </div>
                    <div className={styles.customerBody}>{descriptions}</div>
                  </div>
                )
              )}
              <div className={styles.moneyBack}>
                <HandSvg />
                <h2>{t('onboarding.personalPlan.moneyBack.title')}</h2>
                <span className={styles.firsBody}>
                  {t('onboarding.personalPlan.moneyBack.sub1')}
                </span>
                <span className={styles.secondBody}>
                  {t('onboarding.personalPlan.moneyBack.sub2')}
                </span>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>

      <Timer payment={payment} showDownSaleModalOnce={isDownSaleModalOpen} />
      {showEmailPopup && <EmailPopup isOpen={isEmailPopupOpen} onClose={handleEmailPopupClose} />}

      {showGiftPopup && (
        <GiftPopup isOpen={isGiftPopupOpen} onClose={handleGiftPopupClose} />
      )}
    </>
  );
};

export const Timer = ({ payment, showDownSaleModalOnce }) => {
  const [timeLeft, setTimeLeft] = useState(595);
  const { products } = useRemoteConfig();

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft((prevTime) => {
        if (prevTime <= 1) {
          clearInterval(timer);
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  if (showDownSaleModalOnce) {
    return null;
  }

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
  };

  return (
    <>
      <div className={styles.timer}>
        <div className={styles.time}>
          <span className={styles.timeExpire}>Your Report expires in</span>
          <span style={{ color: '#E768B0' }}>{formatTime(timeLeft)}</span>
        </div>
        <Button title={t('onboarding.personalPlanMetabolism.getReport')} onClick={payment} />
      </div>
    </>
  );
};

export default PersnalPlan;
